import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { loginUser } from '../services/adminServices';
import IpSetup from './IpSetup';
import { CONFIG, MASTERCONFIG } from '../config/general';
import { toast } from 'react-toastify';
import { getAds } from '../services/authServices';


const Login = () => {
  const { login, setLogin, appData, setAds, ads } = useContext(AppContext);
  const [user, setUser] = useState({ username: "", userPassword: "" })
  const [error, setError] = useState(null)
  const [cssLoaded, setCssLoaded] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (appData.expired) {
      toast.error("Your app is expired. Please contact us.")
      return;
    }
    const today = new Date();
    const expiryDate = appData.versionDetails?.expiryDate ? new Date(appData.versionDetails.expiryDate) : null;

    if (appData.isKeyDisabled || (expiryDate && expiryDate < today)) {
      toast.error("Update your admin app.")
      return;
    }
    const result = await loginUser(user)
    if (result.success) {
      setLogin({ ...login, isLogin: true, token: result.token, user: result.user })
      localStorage.setItem("token", result.token)
      localStorage.setItem("userData", JSON.stringify(result.user))
      navigate('/');
    } else {
      setError(result.error)
    }
  };
  const getAdvertisment = async () => {
    try {
      const res = await getAds(2)
      if (!appData.advertisment) {
        setAds(res.ads)
      }
    } catch (error) {
      console.error("Error fetching ads:", error.message);
      return null;
    }
  };

  useEffect(() => {
    if (login.isLogin) navigate("/");
    getAdvertisment()
  }, [])

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "./assets/css/login.css";
    link.onload = () => {
      setCssLoaded(true);
    };
    document.head.appendChild(link);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    if (window.particlesJS && localStorage.getItem("ipConfig")) {
      window.particlesJS("particles-js", {
        particles: {
          number: {
            value: 100,
            density: {
              enable: true,
              value_area: 500,
            },
          },
          color: {
            value: "#9bf51a",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#000000",
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 5,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 250,
            color: "#9bf51a",
            opacity: 0.8,
            width: 1,
          },
          move: {
            enable: true,
            speed: 6,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "repulse",
            },
            onclick: {
              enable: true,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 100,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      });
    }
    return () => {
      const canvas = document.getElementById("particles-js");
      if (canvas) {
        canvas.innerHTML = "";
      }
    };
  }, []);

  const randomTwoAds = useMemo(() => {
    return [...ads].sort(() => 0.5 - Math.random()).slice(0, 2);
  }, [ads]);

  return (
    <>
      {localStorage.getItem("ipConfig") && cssLoaded ? <section className="login_wrapper d-flex align-items-center">
        <div className="container">
          <div className="row g-0 justify-content-center">
            <div className="col-lg-4 p-0">
              <div className="login-wrap text-center">
                <img src={CONFIG.REACT_APP_UPLOADS + "/Icons/logo.png"}
                  style={{ "width": "200px" }}
                  alt="logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "./assets/images/logo.png";
                  }} />
                <h2>Log in</h2>
                <form id="login-form" onSubmit={handleLogin}>
                  <div className="user-name">
                    <input type="text" name="user_name" id="user_name" onChange={(e) => { setUser({ ...user, "username": e.target.value }) }} placeholder="User name" />
                  </div>
                  <div className="password mt-3">
                    <input type="password" name="password" id="password" onChange={(e) => { setUser({ ...user, "userPassword": e.target.value }) }} placeholder="Password" />
                  </div>
                  {window.electronAPI?.isElectron && <div className="forgot-password">
                    <a className="dropdown-item" href="#/config-settings">Configuration</a>
                  </div>}
                  <div className="login-form-btn mt-5">
                    <button type="submit" style={{ border: "none" }} className="form-btn submit">LOG IN</button>
                    <div className='mt-3' style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                      {error && <div><span id="ferror" className="alert alert-danger p-1 mt-3 fw-semibold" role="alert">
                        {error}
                      </span></div>}
                      {Object.keys(appData).length == 0 && <div><span id="ferror" className="alert alert-danger p-1 mt-3 fw-semibold" role="alert">
                        Server Not Connected!
                      </span></div>}
                      {(Object.keys(appData).length > 0 && appData.expired) && <div> <span id="ferror" className="alert alert-danger p-1 mt-3 fw-semibold" role="alert">
                        Your subscription is expired.
                      </span></div>}
                      {(Object.keys(appData).length > 0 && !appData.expired && appData.daysLeft < 5) && <div> <span id="ferror" className="alert alert-info p-1 mt-3 fw-semibold" role="alert">
                        {appData.daysLeft > 0 ? <>Your subscription is expiring in {appData.daysLeft} days. Renew your plan to use this app uninterrupted.</> : <>Your Plan is expiring today</>}
                      </span></div>}
                      <div>
                        {(() => {
                          const { versionDetails } = appData;
                          const expiryDateStr = versionDetails?.expiryDate;
                          const warnDateStr = versionDetails?.warnDate;

                          if (!expiryDateStr) return null;

                          const today = new Date();
                          const expiryDate = new Date(expiryDateStr);
                          const warnDate = warnDateStr ? new Date(warnDateStr) : null;

                          const isExpired = today > expiryDate;
                          const isWarning = warnDate && today >= warnDate && today <= expiryDate;

                          if (isExpired) {
                            return (
                              <div>
                                <span id="ferror" className="alert alert-danger p-1 mt-3 fw-semibold" role="alert">
                                  Your app version has expired. Please update to continue using the app.
                                </span>
                              </div>
                            );
                          }

                          if (isWarning) {
                            const daysLeft = Math.ceil((expiryDate.getTime() - today.getTime()) / (1000 * 3600 * 24));
                            return (
                              <div>
                                <span id="ferror" className="alert alert-info p-1 mt-3 fw-semibold" role="alert">
                                  Your app version will expire in {daysLeft} day{daysLeft !== 1 ? 's' : ''}. Please update soon.
                                </span>
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {ads.length > 0 && <div className="col-lg-3 p-0">
              <div className="login-ad">
                {ads.map((x, index) => (
                  <div key={index} className="ad-container">
                    {
                      x.type == "image" ? <>
                        <img alt={x.htmlContent} src={CONFIG.REACT_APP_UPLOADS + "/" + x.htmlContent} />
                      </> : <>
                        <div dangerouslySetInnerHTML={{ __html: x.htmlContent }} />
                      </>
                    }
                  </div>
                ))}
              </div>
            </div>}
          </div>
        </div>
      </section> : <IpSetup />}
      <div id="particles-js" style={{ "height": "100vh" }}></div>
    </>
  )
}

export default Login
